import { c as _c } from "react/compiler-runtime";
import { Dialog as DialogUI, TextInput } from '@onefootprint/ui';
import { type FormEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const RENAME_FORM_ID = 'rename-artifact-form';

// Controlled rename dialog. Resets the input back to `initialName` each time
// `open` flips false -> true so reopening discards any abandoned edits.
type RenameDialogProps = {
  open: boolean;
  onClose: () => void;
  initialName: string;
  isSaving?: boolean;
  onRename: (newName: string) => void;
};
const RenameDialog = t0 => {
  const $ = _c(39);
  const {
    open,
    onClose,
    initialName,
    isSaving: t1,
    onRename
  } = t0;
  const isSaving = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "actionsMenu.rename"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("artifact", t2);
  const [value, setValue] = useState(initialName);
  let t3;
  let t4;
  if ($[1] !== initialName || $[2] !== open) {
    t3 = () => {
      if (open) {
        setValue(initialName);
      }
    };
    t4 = [open, initialName];
    $[1] = initialName;
    $[2] = open;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== onRename || $[6] !== value) {
    t5 = e => {
      e.preventDefault();
      const trimmed = value.trim();
      if (!trimmed) {
        return;
      }
      onRename(trimmed);
    };
    $[5] = onRename;
    $[6] = value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleSubmit = t5;
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t(_temp2);
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isSaving || $[13] !== value) {
    t8 = value.trim().length === 0 || isSaving;
    $[12] = isSaving;
    $[13] = value;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isSaving || $[16] !== t7 || $[17] !== t8) {
    t9 = {
      label: t7,
      type: "submit",
      form: RENAME_FORM_ID,
      disabled: t8,
      loading: isSaving
    };
    $[15] = isSaving;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp3);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== onClose || $[22] !== t10) {
    t11 = {
      label: t10,
      onClick: onClose
    };
    $[21] = onClose;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t(_temp4);
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== value) {
    t13 = <TextInput size="compact" label={t12} value={value} onChangeText={setValue} autoFocus={true} />;
    $[26] = t12;
    $[27] = value;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== handleSubmit || $[30] !== t13) {
    t14 = <form id={RENAME_FORM_ID} onSubmit={handleSubmit}>{t13}</form>;
    $[29] = handleSubmit;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== onClose || $[33] !== open || $[34] !== t11 || $[35] !== t14 || $[36] !== t6 || $[37] !== t9) {
    t15 = <DialogUI open={open} onClose={onClose} title={t6} size="compact" primaryButton={t9} secondaryButton={t11}>{t14}</DialogUI>;
    $[32] = onClose;
    $[33] = open;
    $[34] = t11;
    $[35] = t14;
    $[36] = t6;
    $[37] = t9;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};
export default RenameDialog;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.save;
}
function _temp3($_1) {
  return $_1.cancel;
}
function _temp4($_2) {
  return $_2.nameLabel;
}